import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body-2" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_4 = { class: "" }

import { computed, PropType } from 'vue'
import parseISO from 'date-fns/parseISO'
import { formatIntlDateAndTime, formatIntlTime } from '@/utils/formatters'
import isSameDay from 'date-fns/isSameDay'
import { StringDate, StringDateTime } from '@/models/shared.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceSelectionOverview',
  props: {
  start: {
    type: [Date, String, null] as PropType<
      Date | StringDateTime | StringDate | null
    >,
    required: true,
  },
  end: {
    type: [Date, String, null] as PropType<
      Date | StringDateTime | StringDate | null
    >,
    required: true,
  },
  groupSize: {
    type: Number,
    required: true,
  },
  /**
   * Use it for calculating total number of all additional services.
   * Supports both the number directly or object where values are quantities
   */
  additionalServices: {
    type: [Object, Number] as PropType<Record<string, number> | number>,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



const startFormatted = computed<string>(() => {
  const parsedStart = parseISO(props.start)
  return formatIntlDateAndTime(parsedStart)
})

const endFormatted = computed<string>(() => {
  const parsedStart = parseISO(props.start)
  const parsedEnd = parseISO(props.end)

  if (isSameDay(parsedStart, parsedEnd)) {
    return '-' + formatIntlTime(parsedEnd)
  }
  return ' - ' + formatIntlDateAndTime(parsedEnd)
})

const totalQuantityOfAdditionalServices = computed<number>(() =>
  Object.values(props.additionalServices).reduce(
    (total, quantity) => (total += quantity),
    0,
  ),
)

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(startFormatted)) + _toDisplayString(_unref(endFormatted)) + ", ", 1),
    _createVNode(_component_i18n_t, {
      keypath: "plurals.numberOfParticipants",
      tag: "span",
      plural: __props.groupSize
    }, {
      count: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.groupSize), 1)
      ]),
      _: 1
    }, 8, ["plural"]),
    (_unref(totalQuantityOfAdditionalServices))
      ? (_openBlock(), _createBlock(_component_i18n_t, {
          key: 0,
          keypath: "plurals.numberOfAdditionalServices",
          tag: "span",
          plural: _unref(totalQuantityOfAdditionalServices)
        }, {
          count: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(totalQuantityOfAdditionalServices)), 1)
          ]),
          _: 1
        }, 8, ["plural"]))
      : _createCommentVNode("", true)
  ]))
}
}

})